import * as ko from "knockout";
import {config, global} from "../appContext";
import {storeObservable} from "./sessionstore";
import {KOSubscriptionTracker} from "./KOSubscriptionTracker";
import {PermissionValidator} from "../auth/PermissionValidator";
import {memoryStore} from "./memorystore";
import pubsub from "../pubsub";

export class StateCss {
    private static readonly cls_Focus = 'g-focusin';
    private static readonly FocusListenerPeriodMs = 60 * 1000;
    private pv!: PermissionValidator;
    private focusTimeout!: number;
    private readonly kosub = new KOSubscriptionTracker();
    private root: HTMLElement = document.querySelector(':root')!;
    public useEAdmStylesheet: KnockoutObservable<boolean> = ko.observable(true)
    public useEHubStylesheet: KnockoutObservable<boolean> = ko.observable(false)
    private showBody: KnockoutObservable<boolean> = ko.observable(true)

    constructor() {
        window.addEventListener('focus', this.onFocus.bind(this))
    }

    public init() {
        this.pv = global.permissionValidator
        this.kosub.subscribe(global.eHubManager.isStarted, bool => {
            this.showBody(false)
            window.requestAnimationFrame(() => {
                this.useEAdmStylesheet(!bool)
                this.useEHubStylesheet(bool)
                window.requestAnimationFrame(() => {
                    this.showBody(true)
                })
            })
        })
    }

    private onFocus() {
        clearTimeout(this.focusTimeout)
        this.root.classList.toggle(StateCss.cls_Focus, true);
        this.focusTimeout = setTimeout(() => {
            this.root.classList.toggle(StateCss.cls_Focus, false);
        }, StateCss.FocusListenerPeriodMs)
    }

    public state: KnockoutComputed<string | null> = ko.pureComputed((): string | null => {
        if (!global.isReady()) {
            return null
        }
        const ret = [
            // the role of the user (0, 1, 2, 4, 8, 16)
            // ex: .g-ro--16
            'g-ro--' + this.pv.role(),

            // whether to show body content in full width
            // ex: .g-full-width--true
            'g-full-width--' + (storeObservable("css.block.fullwidth")() && global.login.isLoggedIn()),

            // ex: .g-warning--true
            'g-warning--' + storeObservable("production.warning")(),

            // whether the eHub v2 application is showing
            // ex: .eh2--1
            'eh2--' + (this.useEHubStylesheet() ? 1 : 0),

            // whether to display the main menu and header interactive elements
            // ex: .g-interact--1
            'g-interact--' + Number(memoryStore.get('show.app.interact')()),
        ];

        // whether the application is running in production mode
        // ex: .g-pr;
        if (config.isLoaded() && !config.DEBUG) {
            ret.push('g-pr')
        } else {
            ret.push('g-dev')
        }

        // whether superuser is logged in (and emulating another user)
        // ex: .g-ro--su,
        if (global.loginManager.isUserSA()) {
            ret.push('g-ro--su');
        }

        ret.push('show-body--' + this.showBody())

        return ret.join(" ");
    })

    dispose() {
        window.removeEventListener('focus', this.onFocus)
        this.kosub.unsuscribeAll();
        pubsub.off(this)
    }
}